import React from 'react';
import { PrivateRoute } from './PrivateRoute';
import routes from '@/config/routes';
import { Terms } from '@/pages/public/Terms';
import { Route } from 'react-router-dom';
import { Privacy } from '@/pages/public/Privacy';
import { getAuthRoutes } from './authRoutes';

export const getCommonRoutes = (): React.ReactElement[] => {
  const SP_UserProfile = React.lazy(() => import('@/pages/agent/user'));
  const Mail = React.lazy(() => import('@/pages/communications/mail'));
  const Chat = React.lazy(() => import('@/pages/communications/chat'));
  const ServiceRequest = React.lazy(() => import('@/pages/communications/serviceRequest'));
  const RemoteSupport = React.lazy(() => import('@/pages/communications/remoteSupport'));
  const GigApply = React.lazy(() => import('@/components/auth/GigApply'));
  const MarkAttendance = React.lazy(() => import('@/components/auth/MarkAttendance'));
  const NewPassword = React.lazy(() => import('@/components/auth/NewPassword'));
  const StageTwoRedirect = React.lazy(
    () => import('@/components/agent/resume-builder/congratulations/stage-two-redirect'),
  );

  const items: React.ReactElement[] = [
    <PrivateRoute
      key={routes.sp.scheduling.user.profile.index}
      path={routes.sp.scheduling.user.profile.index}
      component={SP_UserProfile}
    />,
    <PrivateRoute
      key={routes.sp.communicationsMenu.remoteSupport}
      path={routes.sp.communicationsMenu.remoteSupport}
      component={RemoteSupport}
    />,
    <PrivateRoute
      key={routes.sp.communicationsMenu.serviceRequest}
      path={routes.sp.communicationsMenu.serviceRequest}
      component={ServiceRequest}
    />,
    <PrivateRoute key={routes.sp.communicationsMenu.mail} path={routes.sp.communicationsMenu.mail} component={Mail} />,
    <PrivateRoute key={routes.sp.communicationsMenu.chat} path={routes.sp.communicationsMenu.chat} component={Chat} />,
    <PrivateRoute key={`common-${routes.auth.gigApply}`} path={routes.auth.gigApply} component={GigApply} />,
    <PrivateRoute key={`common-${routes.auth.stageTwo}`} path={routes.auth.stageTwo} component={StageTwoRedirect} />,
    <PrivateRoute
      key={`common-${routes.auth.newPassword.index}`}
      path={routes.auth.newPassword.index}
      component={NewPassword}
    />,
    <Route key={`common-${routes.auth.terms}`} path={routes.auth.terms} render={() => <Terms />} />,
    <Route key={`common-${routes.auth.privacy}`} path={routes.auth.privacy} render={() => <Privacy />} />,
    <PrivateRoute
      key={`common-${routes.auth.markAttendance}`}
      path={routes.auth.markAttendance}
      component={MarkAttendance}
    />,
  ];
  getAuthRoutes().forEach(item => items.push(item));
  return items;
};
